import CombinedIcon from "./CombinedIcon";

/* Base icon and the "extra" badge (suite ★) are admin-configured
   (RoomTypesTab → "Additional Settings"), falling back to "bed"/none for any
   room type nobody has set up yet. Bed-count badges are NOT part of that
   config — they always come live from the real RoomType.capacity, so
   editing Capacity keeps working regardless of what's configured. They only
   apply when the base icon is actually "bed" — a venue-charge type like
   Conference Hall gets a non-"bed" base icon precisely so its capacity
   (headcount, not beds) doesn't spawn bed badges. */
export function roomTypeIconSpec(capacity, attrs) {
  const baseIcon = attrs?.icon || "bed";
  const typeBadge = attrs?.extraIcon || null;
  const bedCount = baseIcon === "bed" ? Math.max(1, capacity || 1) : 0;
  return { baseIcon, typeBadge, bedCount };
}

export default function RoomTypeIcon({ capacity, attrs, color, overdue }) {
  const { baseIcon, typeBadge, bedCount } = roomTypeIconSpec(capacity, attrs);
  /* Every bed-type room gets a "×N" total bed-count badge, including ×1 —
     one compact badge per room rather than one repeated bed-icon badge per
     bed (a triple room used to crowd the circle with 2 tiny bed glyphs).
     The overdue warning goes first so it claims the most prominent orbit
     slot, and carries its own orange color independent of room status. */
  const badges = [
    // Overdue warning badge disabled for now — re-enable by uncommenting.
    // ...(overdue ? [{ icon: "warning sign", color: "orange" }] : []),
    ...(typeBadge ? [typeBadge] : []),
    ...(bedCount > 0 ? [{ text: `×${bedCount}` }] : []),
  ];
  return <CombinedIcon baseIcon={baseIcon} color={color} badges={badges} />;
}
